import { render, staticRenderFns } from "./icon_badge.vue?vue&type=template&id=4fea7cb3&scoped=true&"
import script from "./icon_badge.vue?vue&type=script&lang=js&"
export * from "./icon_badge.vue?vue&type=script&lang=js&"
import style0 from "./icon_badge.vue?vue&type=style&index=0&id=4fea7cb3&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fea7cb3",
  null
  
)

export default component.exports